var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-container",attrs:{"id":"st-container"}},[_c('NavMenu'),_c('ContentWrapper')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }